import { useContext } from 'react';
import type { INeedContentContextProps } from './need-content-context';
import { needContentContext } from './need-content-context';

/**
 * Hook that returns the values of the NeedContentContext.
 * @return {INeedContentContextProps}
 */
export function useNeedContentContext(): INeedContentContextProps {
    const context = useContext(needContentContext);
    if (context == null) throw new Error('useNeedContentContext must be used within a <NeedContentProvider>');

    return context;
}
